/* eslint-disable jsx-a11y/no-noninteractive-tabindex */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { ReactElement, useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import { CSSTransition, TransitionGroup } from "react-transition-group"

import { getDocument } from "shared/lib/getDocument"
import { preventDefaultAndStopPropagation } from "shared/lib/preventDefaultAndStopPropagation"
import usePrevious from "shared/lib/usePrevious"

import { usePreventWindowScroll } from "features/scroll-management/model/usePreventWindowScroll"
import { ModalCloseButton } from "widgets/modal/ModalCloseButton"

import "./styles/_modal.scss"

export interface ModalProps {
  children: ReactElement | null
  preventPortal?: boolean
  isHidden?: boolean
  onClose?: () => void
  onAfterClose?: () => void
}

export const Modal = React.memo(
  ({
    children,
    preventPortal,
    isHidden,
    onClose,
    onAfterClose
  }: ModalProps) => {
    const nodeRef = useRef(null)

    const modalRoot = getDocument()?.getElementById("app-content")
    usePreventWindowScroll({
      id: "modal",
      isScrollDisabled: !isHidden && !preventPortal
    })

    const isOpenPrevious = usePrevious(!isHidden && !preventPortal)

    useEffect(() => {
      if ((isHidden || preventPortal) && isOpenPrevious) {
        onAfterClose?.()
      }
    }, [isHidden, preventPortal])

    if (!modalRoot && isHidden) {
      return null
    }
    if (!modalRoot || preventPortal) {
      return children
    }

    return createPortal(
      <TransitionGroup component={null}>
        {isHidden ? null : (
          <CSSTransition
            nodeRef={nodeRef}
            in
            timeout={200}
            classNames="modal-container"
            unmountOnExit
            onExited={onAfterClose}
          >
            <dialog aria-modal className="modal-container" ref={nodeRef}>
              <div className="modal__content" tabIndex={0}>
                {children}
              </div>
              {onClose ? (
                <div
                  className="modal__close-button-container"
                  onClick={preventDefaultAndStopPropagation}
                >
                  <ModalCloseButton onClick={onClose} />
                </div>
              ) : null}
            </dialog>
          </CSSTransition>
        )}
      </TransitionGroup>,
      modalRoot
    )
  }
)
